'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createProvinceListQueryOptions } from '@/modules/shared/contracts';
import type { ProvinceListQueryOptions } from '@/modules/shared/contracts';

import type { LocationRegion } from '@packages/contracts';

export const useProvinceListQuery = (region?: LocationRegion, options?: Partial<ProvinceListQueryOptions>) => {
	const queryOptions = createProvinceListQueryOptions(region);

	return tsrShared.locations.province.list.useQuery({
		...queryOptions,
		...options,
	});
};
